import Styled from './section_feedBacks.module.css'
import * as CG from '../../../Components/Global'
import * as FA from 'react-icons/fa'
import * as FI from 'react-icons/fi'
import { useLandingContext } from '../../../Context'
import imgEmpty from '../../../Assets/server-woman-colour.svg'

const SectionFeedBacks = () => {
    const useLanding = useLandingContext()
    const isEmpty = useLanding.feedBacks.length > 0
    return (
        <section id="depoimentos" className={Styled.container_feedbacks}>
            <CG.H2>Depoimentos</CG.H2>

            <article className={isEmpty ? Styled.animation_slider : ''} id={Styled.card_slider}>
                {isEmpty ? (
                    <>
                        <FA.FaQuoteLeft />
                        <p>{useLanding.feedBackActive.name}</p>
                        <hr />
                        <p>{useLanding.feedBackActive.feedBack}</p>
                        <FA.FaQuoteRight />
                    </>
                ) : (
                    <div className={Styled.empty}>
                        <img src={imgEmpty} alt="Nenhum depoimento" />
                        <span>Nada a ser exibido!</span>
                    </div>
                )}
            </article>

            {isEmpty && (
                <div className={Styled.container_btn}>
                    <button type="button" onClick={() => useLanding.handleToggleActiveFeedBack('old')}>
                        <FI.FiChevronLeft />
                    </button>
                    <button type="button" onClick={() => useLanding.handleToggleControllerStop()}>
                        {useLanding.controllerStop ? <FI.FiPlayCircle /> : <FI.FiPauseCircle />}
                    </button>
                    <button type="button" onClick={() => useLanding.handleToggleActiveFeedBack('next')}>
                        <FI.FiChevronRight />
                    </button>
                </div>
            )}
        </section>
    )
}

export default SectionFeedBacks